import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { YesNoDialogComponent } from "../components/dialog/yes-no-dialog/yes-no-dialog.component";
import { ErrorDialogComponent } from "../components/dialog/error-dialog/error-dialog.component";
import { LanguageSelectorDialogComponent } from "../components/dialog/language-selector-dialog/language-selector-dialog.component";
import { MessageDialogComponent } from "../components/dialog/message-dialog/message-dialog.component";
import { LanguageSelectorResponse } from "../dtos/language-selector.response.dto";
import { ErrorDialogData } from "../components/dialog/error-dialog/error-dialog-data";
import { MessageDialogData } from "../components/dialog/message-dialog/message-dialog-data";
import { YesNoDialogData } from "../components/dialog/yes-no-dialog/yes-no-dialog-data";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: 'root' })
export class DialogService {
    private yesNoDialog = inject(MatDialog);
    private errorDialog = inject(MatDialog);
    private languageSelector = inject(MatDialog);
    private messageDialog = inject(MatDialog);
    protected translateService = inject(TranslateService);

    async openYesNoDialog(question: string, yesButtonText: string | undefined = undefined, noButtonText: string | undefined = undefined) {
        if (!yesButtonText)
            yesButtonText = this.translateService.instant("common.yes");

        if (!noButtonText)
            noButtonText = this.translateService.instant("common.no");

        let yesNoDialogData: YesNoDialogData = {
            question: question,
            yesButtonText: yesButtonText!,
            noButtonText: noButtonText!
        };

        const dialogParams: any = {
            data: yesNoDialogData,
        };

        return new Promise((resolve) => {
            this.yesNoDialog.open(YesNoDialogComponent, dialogParams)
                .afterClosed()
                .subscribe((result: Boolean) => {
                    resolve(result);
                });
        });
    }

    showError(errors: string[], title?: string): any {
        let errorDialogData: ErrorDialogData = new ErrorDialogData();

        errorDialogData.title = title;

        if (errors)
            errorDialogData.errors = errors;

        const dialogParams: any = {
            data: errorDialogData,
        };

        //if (!this.isMobile) {
        //  dialogParams.minHeight = '150px';
        //  dialogParams.minWidth = '600px';
        //}

        return this.errorDialog.open(ErrorDialogComponent, dialogParams);
    }

    async openLanguageSelectorDialog(languages: LanguageSelectorResponse[]) {

        const dialogParams: any = {
            data: languages,
        };

        return new Promise((resolve) => {

            this.yesNoDialog.open(LanguageSelectorDialogComponent, dialogParams)
                .afterClosed()
                .subscribe((languageCode: string) => {
                    resolve(languageCode);
                });
        });
    }

    showMessage(text: string, title?: string): any {
        let messageDialogData: MessageDialogData = new MessageDialogData();

        return this.showMessageList([text], title);
    }

    showMessageList(texts: string[], title?: string): any {
        let messageDialogData: MessageDialogData = new MessageDialogData();

        messageDialogData.title = title;
        messageDialogData.texts = texts;

        const dialogParams: any = {
            data: messageDialogData,
        };

        return this.messageDialog.open(MessageDialogComponent, dialogParams);
    }
}
